import request from '@/utils/request'

// 红包记录
export function redPacketRecord(params = {}) {
  return request({
    url: '/capital/redPacket/list',
    method: 'get',
    params
  })
}

// 公众号绑定的商户号列表
export function merchantIDList(params = {}) {
  return request({
    url: '/capital/merchantBindOa/list',
    method: 'get',
    params
  })
}

// 领取红包
export function receiveRedEnvelope(data = {}) {
  return request({
    url: '/activity/redPacket/receiveRedPacket',
    method: 'post',
    data
  })
}

// 创建红包活动
export function createRedPacket(data = {}) {
  return request({
    url: '/activity/redPacket/create',
    method: 'post',
    data
  })
}

// 红包活动列表
export function redPacketActivitylist(params = {}) {
  return request({
    url: '/activity/redPacket/list',
    method: 'get',
    params
  })
}

// 红包活动状态更新
export function redPacketActivityStatusUpdate(data = {}) {
  return request({
    url: '/activity/redPacket/updateStatus',
    method: 'post',
    data
  })
}

// 红包活动绑定公众号
export function redEnvelopeActivityBindingPublicAccount(data = {}) {
  return request({
    url: '/activity/redPacket/bindOas',
    method: 'post',
    data
  })
}

// 商品号列表
export function commodityNumberList(params = {}) {
  return request({
    url: '/capital/merchant/list',
    method: 'get',
    params
  })
}

// 修改商户号状态
export function modifyMerchantIDStatus(data = {}) {
  return request({
    url: '/capital/merchant/updateMerchant',
    method: 'post',
    data
  })
}

// 创建商户号
export function createMerchantID(data = {}) {
  return request({
    url: '/capital/merchant/create',
    method: 'post',
    data
  })
}
// 解绑
export function unbandlist(params = {}) {
  return request({
    url: '/capital/merchantBindOa/unbind',
    method: 'get',
    params
  })
}

// 解绑
export function sort(data = {}) {
  return request({
    url: '/workWechat/kfMsg/updateMsgSort',
    method: 'post',
    data
  })
}
// 查看密码
export function officialPwd(params = {}) {
  return request({
    url: '/scanNumberInfo/officialPwd',
    method: 'get',
    params
  })
}

// 更新商户号的余额或设置阈值
export function updataamount(data = {}) {
  return request({
    url: '/capital/merchant/updateAmount',
    method: 'post',
    data
  })
}
// 客服消息列表
export function groupWelcomeindex(params) {
  return request({
    url: '/spWorkWechat/groupWelcome/index',
    method: 'get',
    params
  })
}
// 群欢迎语删除
export function groupWelcomedelete(data = {}) {
  return request({
    url: '/spWorkWechat/groupWelcome/delete',
    method: 'post',
    data
  })
}
// 群欢迎语新增
export function groupWelcomestore(data = {}) {
  return request({
    url: '/spWorkWechat/groupWelcome/store',
    method: 'post',
    timeout: 30 * 1000,
    data
  })
}
// 群欢迎语编辑
export function groupWelcomeupdate(data = {}) {
  return request({
    url: '/spWorkWechat/groupWelcome/update',
    method: 'post',
    data
  })
}
